import { useQuery, UseQueryResult } from '@tanstack/react-query';
import {
	ManpowerWorkersApiService,
	ListWorkersResponse,
	ListWorkersParams,
} from '../../../services/manpowerWorkersApi';

/** List workers, optionally filtered by vendor / facility. */
export const useWorkerData = (
	params?: ListWorkersParams
): UseQueryResult<ListWorkersResponse, Error> => {
	return useQuery({
		queryKey: ['manpower', 'workers', 'listing', params?.vendorId, params?.facilityId],
		queryFn: async (): Promise<ListWorkersResponse> => {
			return ManpowerWorkersApiService.listWorkers(params);
		},
		staleTime: 0,
		gcTime: 0,
		refetchOnMount: true,
		refetchOnWindowFocus: false,
		retry: 1,
	});
};
